// src/App.js
import React, { useState, useEffect } from 'react';
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';

import Auth from './Auth';
import KeycodeGenerator from './KeycodeGenerator';
import KeycodeInput from './KeycodeInput';
import { Container } from 'react-bootstrap'; // Import Container

// No App.css import needed if all styling is handled by react-bootstrap

function App() {
    const [user, setUser] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoadingAuth(false);
        });

        return () => unsubscribe();
    }, []);

    if (loadingAuth) {
        return (
            <Container className="text-center my-5">
                <p className="h4">Ladataan autentikointia...</p>
            </Container>
        );
    }

    return (
        <Container> {/* Use react-bootstrap Container for the main app layout */}
            <Auth user={user} />
            <KeycodeGenerator user={user} />
            <KeycodeInput user={user} />
        </Container>
    );
}

export default App;